import { NgModule, Component } 			from '@angular/core';
import {ToasterModule, ToasterService} 	from 'angular2-toaster';


@Component({
    selector: 'body',
    template: `
    <div *ngIf="loading == true" class="loader">Loading..</div>
    <router-outlet></router-outlet>
    <toaster-container></toaster-container>`
})
export class AppComponent { 

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts